import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConnectionDto } from 'src/app/dtos/connection.dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  private apiUrl = environment.apiUrl + '/api/live';

  constructor(private http: HttpClient) { }

  sendConnectionIdToServer(connection: ConnectionDto): Observable<ConnectionDto> {
    return this.http.post<ConnectionDto>(`${this.apiUrl}`, connection);
  }

}
